.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex: 1;
  overflow-x: clip;
  container-type: inline-size;
}
